import React, { useState, useEffect, useRef } from 'react';

function Testimonials() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const trackRef = useRef(null);
  const totalSlides = 3;

  const testimonials = [
    {
      name: '李女士',
      initial: 'L',
      date: '2024.03.15',
      text: '蛋糕太精致了！朋友生日定制的，完全舍不得切开。味道也超棒，奶油入口即化',
      rating: '★★★★★'
    },
    {
      name: '王先生',
      initial: 'W',
      date: '2024.03.10',
      text: '婚礼蛋糕定制服务太专业了，完全按照我的要求来设计，宾客们都赞不绝口！',
      rating: '★★★★★'
    },
    {
      name: '张女士',
      initial: 'Z',
      date: '2024.03.08',
      text: '马卡龙礼盒送人很有面子，每一颗都精致美味，已经回购好几次了',
      rating: '★★★★★'
    }
  ];

  useEffect(() => {
    const autoplay = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % totalSlides);
    }, 5000);

    return () => clearInterval(autoplay);
  }, []);

  useEffect(() => {
    if (trackRef.current) {
      const slideWidth = trackRef.current.querySelector('.testimonial-card').offsetWidth + 24;
      trackRef.current.scrollTo({
        left: slideWidth * currentSlide,
        behavior: 'smooth'
      });
    }
  }, [currentSlide]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrev = () => {
    setCurrentSlide(prev => Math.max(0, prev - 1));
  };

  const goToNext = () => {
    setCurrentSlide(prev => Math.min(totalSlides - 1, prev + 1));
  };

  return (
    <section className="testimonials">
      <div className="container">
        <div className="section-header centered">
          <span className="section-label">客户评价</span>
          <h2 className="section-title">甜蜜分享</h2>
        </div>
        <div className="testimonials-slider">
          <div 
            className="testimonials-track" 
            ref={trackRef}
            onMouseEnter={() => {
              // Auto-play pause logic could be added here
            }}
          >
            {testimonials.map((testimonial, index) => (
              <div className="testimonial-card" key={index}>
                <div className="testimonial-rating">{testimonial.rating}</div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <div className="author-avatar">{testimonial.initial}</div>
                  <div className="author-info">
                    <span className="author-name">{testimonial.name}</span>
                    <span className="author-date">{testimonial.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="testimonials-nav">
            <button className="nav-arrow prev" onClick={goToPrev}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 18l-6-6 6-6"/>
              </svg>
            </button>
            <div className="testimonials-dots">
              {Array.from({ length: totalSlides }).map((_, index) => (
                <span 
                  key={index}
                  className={`dot ${currentSlide === index ? 'active' : ''}`}
                  data-index={index}
                  onClick={() => goToSlide(index)}
                ></span>
              ))}
            </div>
            <button className="nav-arrow next" onClick={goToNext}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
